import { IMeasurementFillerTypes, IMeasurementFillerObservationTypes, IObservationType, IBloodGlucoseType } from "../models/manual-data-recording.models";
import { ICodeableConcept, IObservation, IObservation_Component, IQuantity } from "@ahryman40k/ts-fhir-types/lib/R4";
import { ObservationConstants } from "./fhir-observation.constants";
// import { ObservationConstants } from "@inclouded/fhir-observation";

export const MEASUREMENT_FILLER_TYPE_CONSTANTS: IMeasurementFillerTypes = {
    add: 'Add',
    modify: 'Modify'
};

export const MEASUREMENT_FILLER_OBSERVATION_TYPES: IMeasurementFillerObservationTypes = {
    bloodPressure: 'bloodpressure',
    bodyWeight: 'weight',
    bloodGlucose: 'glucose',
    nutrition: 'nutrition',
    activityMiband: 'activityMiband',
    activityPolar: 'activityPolar',
    trainingPolar: 'trainingPolar',
    stepper: 'stepper',
    bioparameters: 'bioparameters'
};

export const OBSERVATION_TYPES: IObservationType[] = [
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.bloodPressure, text: 'OBS_TYPE_BLOOD_PRESSURE', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.bodyWeight, text: 'OBS_TYPE_BODY_WEIGHT', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.bloodGlucose, text: 'OBS_TYPE_BLOOD_GLUCOSE', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.nutrition, text: 'OBS_TYPE_NUTRITION', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.activityMiband, text: 'OBS_TYPE_ACTIVITY_MIBAND', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.activityPolar, text: 'OBS_TYPE_ACTIVITY_POLAR', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.trainingPolar, text: 'OBS_TYPE_TRAINING_POLAR', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.stepper, text: 'OBS_TYPE_STEPPER', disabled: false },
    { type: MEASUREMENT_FILLER_OBSERVATION_TYPES.bioparameters, text: 'OBS_TYPE_BIOPARAMETERS', disabled: false }
];

export const BLOOD_GLUCOSE_TYPES: IBloodGlucoseType[] = [
    { text: 'GENERAL', value: 0 },
    { text: 'PRE_MEAL', value: 1 },
    { text: 'POST_MEAL', value: 2 }
];

export const RAW_FHIR_OBSERVATION: IObservation = {
    resourceType: 'Observation',
    id: null,
    meta: { lastUpdated: null },
    issued: null,
    code: null,
    subject: { reference: null },
    effectiveDateTime: null,
    device: { reference: null }
};

export const FHIR_OBSERVATION_CODE_BLOOD_PRESSURE: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodPressureCode,
        display: ObservationConstants.BloodPressureDisplay
    }],
    text: ObservationConstants.BloodPressureText
};

export const FHIR_OBSERVATION_CODE_BODY_WEIGHT: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BodyWeightCode,
        display: ObservationConstants.BodyWeightDisplay
    }],
    text: ObservationConstants.BodyWeightText
};

export const FHIR_OBSERVATION_CODE_BLOOD_GLUCOSE: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodGlucoseCode,
        display: ObservationConstants.BloodGlucoseDisplay,
    }],
    text: ObservationConstants.BloodGlucoseText
};

export const FHIR_OBSERVATION_CODE_BLOOD_GLUCOSE_PRE_MEAL: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodGlucosePreMealCode,
        display: ObservationConstants.BloodGlucosePreMealDisplay,
    }],
    text: ObservationConstants.BloodGlucosePreMealText
};

export const FHIR_OBSERVATION_CODE_BLOOD_GLUCOSE_AFTER_MEAL: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodGlucosePostMealCode,
        display: ObservationConstants.BloodGlucosePostMealDisplay,
    }],
    text: ObservationConstants.BloodGlucosePostMealText
};

export const FHIR_OBSERVATION_CODE_NUTRITION: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.NutrientCode,
        display: ObservationConstants.NutrientDisplay,
    }],
    text: ObservationConstants.NutrientText
};

export const FHIR_OBSERVATION_CODE_ACTIVITY_MIBAND: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PhysicalActivityPanelCode,
        display: ObservationConstants.PhysicalActivityPanelDisplay,
    }],
    text: ObservationConstants.PhysicalActivityPanelText
};

export const FHIR_OBSERVATION_CODE_ACTIVITY_POLAR: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ActivityCode,
        display: ObservationConstants.ActivityDisplay,
    }],
    text: ObservationConstants.ActivityText
};

export const FHIR_OBSERVATION_CODE_TRAINING_POLAR: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.RealtimePusoxiStepsCode,
        display: ObservationConstants.RealtimePusoxiStepsDisplay,
    }],
    text: ObservationConstants.RealtimePusoxiStepsText
};

export const FHIR_OBSERVATION_CODE_STEPPER: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SteppingSessionCode,
        display: ObservationConstants.SteppingSessionDisplay,
    }],
    text: ObservationConstants.SteppingSessionText
};

export const FHIR_OBSERVATION_CODE_BIOPARAMETERS: ICodeableConcept = {
    coding: [{
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BioparametersCode,
        display: ObservationConstants.BioparametersDisplay,
    }],
    text: ObservationConstants.BioparametersText
};

export const FHIR_OBSERVATION_VALUE_BLOODPRESSURE: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.SystolicCode,
                display: ObservationConstants.SystolicDisplay
            }, {
                system: 'http://snomed.info/sct',
                code: '271649006',
                display: 'Systolic blood pressure'
            }, {
                system: 'http://acme.org/devices/clinical-codes',
                code: 'bp-s',
                display: 'Systolic Blood pressure'
            }],
            text: ObservationConstants.SystolicText
        },
        valueQuantity: {
            value: null,
            unit: 'mmHg',
            system: 'http://unitsofmeasure.org',
            code: 'mm[Hg]'
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.DiastolicCode,
                display: 'Diastolic blood pressure'
            }],
            text: ObservationConstants.DiastolicText
        },
        valueQuantity: {
            value: null,
            unit: 'mmHg',
            system: 'http://unitsofmeasure.org',
            code: 'mm[Hg]'
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateCode,
                display: ObservationConstants.HeartRateDisplay
            }],
            text: ObservationConstants.HeartRateText
        },
        valueQuantity: {
            value: null,
            unit: 'beats/minute',
            system: 'http://unitsofmeasure.org',
            code: '/min'
        }
    }
];

export const FHIR_OBSERVATION_VALUE_BODYWEIGHT: IQuantity = {
    value: null,
    unit: ObservationConstants.Kilogram,
    system: 'http://unitsofmeasure.org',
    code: ObservationConstants.Kilogram
};

export const FHIR_OBSERVATION_VALUE_BLOOD_GLUCOSE: IQuantity = {
    value: null,
    unit: 'mg/dl',
    system: 'http://unitsofmeasure.org',
    code: 'mg/dl'
};

export const FHIR_OBSERVATION_VALUE_NUTRITION: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.CalorieIntakePanelCode,
                display: ObservationConstants.CalorieIntakePanelCodeDisplay,
            }],
            text: ObservationConstants.CalorieIntakePanelCodeText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Calories,
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.CarbohydrateIntakePanelCode,
                display: ObservationConstants.CarbohydrateIntakePanelDisplay
            }],
            text: ObservationConstants.CarbohydrateIntakePanelCodeText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.gramm
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.LoggingActivityCode,
                display: ObservationConstants.LoggingActivityDisplay
            }],
            text: ObservationConstants.LoggingActivityText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.unit,
        }
    }
];

export const FHIR_OBSERVATION_VALUE_ACTIVITY_MIBAND: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.StepActivityCode,
                display: ObservationConstants.StepActivityDisplay
            }],
            text: ObservationConstants.StepActivityText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Steps,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Steps
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.DistanceCode,
                display: ObservationConstants.DistanceActivityDisplay
            }],
            text: ObservationConstants.DistanceActivityText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Meter,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Meter
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.BurntCaloriesActivityCode,
                display: ObservationConstants.BurntCaloriesActivityDisplay
            }],
            text: ObservationConstants.BurntCaloriesActivityText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Calories,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Calories
        }
    }
];

export const FHIR_OBSERVATION_VALUE_ACTIVITY_POLAR: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.StepActivityCode,
                display: ObservationConstants.StepActivityDisplay
            }],
            text: ObservationConstants.StepActivityText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Steps,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Steps
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.BurntCaloriesActivityCode,
                display: ObservationConstants.BurntCaloriesActivityDisplay
            }],
            text: ObservationConstants.BurntCaloriesActivityText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Calories,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Calories
        }
    }
];

export const FHIR_OBSERVATION_VALUE_TRAINING_POLAR: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.ExerciseTypeCode,
                display: ObservationConstants.ExerciseTypeDisplay
            }],
            text: ObservationConstants.ExerciseTypeText
        },
        valueString: null
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.CaloriesBurnedCode,
                display: ObservationConstants.CaloriesBurnedDisplay
            }],
            text: ObservationConstants.CaloriesBurnedText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Calories
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.MaxHeartBeatCode,
                display: ObservationConstants.MaxHeartBeatDisplay
            }],
            text: ObservationConstants.MaxHeartBeatText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateLvl1Code,
                display: ObservationConstants.HeartRateLvl1Display
            }],
            text: ObservationConstants.HeartRateLvl1Text
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort
        },
        valueRange: {
            high: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            },
            low: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            }
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateLvl2Code,
                display: ObservationConstants.HeartRateLvl2Display
            }],
            text: ObservationConstants.HeartRateLvl2Text
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort
        },
        valueRange: {
            high: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            },
            low: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            }
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateLvl3Code,
                display: ObservationConstants.HeartRateLvl3Display
            }],
            text: ObservationConstants.HeartRateLvl3Text
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort
        },
        valueRange: {
            high: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            },
            low: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            }
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateLvl4Code,
                display: ObservationConstants.HeartRateLvl4Display
            }],
            text: ObservationConstants.HeartRateLvl4Text
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort
        },
        valueRange: {
            high: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            },
            low: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            }
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateLvl5Code,
                display: ObservationConstants.HeartRateLvl5Display
            }],
            text: ObservationConstants.HeartRateLvl5Text
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort
        },
        valueRange: {
            high: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            },
            low: {
                value: null,
                unit: ObservationConstants.BeatsPerMinuteShort
            }
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.ExerciseIntensityCode,
                display: ObservationConstants.ExerciseIntensityDisplay
            }],
            text: ObservationConstants.ExerciseIntensityText
        },
        valueQuantity: {
            value: null
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.ExerciseDurationCode,
                display: ObservationConstants.ExerciseDurationDisplay
            }],
            text: ObservationConstants.ExerciseDurationText
        },
        valueTime: null
    }
];

export const FHIR_OBSERVATION_VALUE_STEPPER: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.StepsTakenCode,
                display: ObservationConstants.StepsTakenDisplay
            }],
            text: ObservationConstants.StepsTakenText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Steps,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Steps
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.TimePeriodStepsTakenCode,
                display: ObservationConstants.TimePeriodStepsTakenDisplay
            }],
            text: ObservationConstants.TimePeriodStepsTakenText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Minute,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Minute
        }
    }
];

export const FHIR_OBSERVATION_VALUE_BIOPARAMETERS: IObservation_Component[] = [
    {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.SystolicCode,
                display: ObservationConstants.SystolicDisplay
            }],
            text: ObservationConstants.SystolicText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.MillimetreOfMercury,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.MillimetreOfMercury
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.DiastolicCode,
                display: ObservationConstants.DiastolicText
            }],
            text: ObservationConstants.DiastolicText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.MillimetreOfMercury,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.MillimetreOfMercury
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.HeartRateCode,
                display: ObservationConstants.HeartRateDisplay
            }],
            text: ObservationConstants.HeartRateText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BeatsPerMinuteShort,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.BeatsPerMinuteShort
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.BodyWeightCode,
                display: ObservationConstants.BodyWeightDisplay
            }],
            text: ObservationConstants.BodyWeightText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.Kilogram,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.Kilogram
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.BodyHeightCode,
                display: ObservationConstants.BodyHeightDisplay
            }],
            text: ObservationConstants.BodyHeightText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.CentiMeter,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.CentiMeter
        }
    }, {
        code: {
            coding: [{
                system: ObservationConstants.ObservationSystem,
                code: ObservationConstants.BMIRatioCode,
                display: ObservationConstants.BMIRatioDisplay
            }],
            text: ObservationConstants.BMIRatioText
        },
        valueQuantity: {
            value: null,
            unit: ObservationConstants.BMIRationUnit,
            system: 'http://unitsofmeasure.org',
            code: ObservationConstants.BMIRationUnit
        }
    }
];